import PageLoader from 'components/Shared/PageLoader';
import React, { useEffect } from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { useObservable } from 'react-use-observable';
import authService from 'services/auth';

import AdminPage from './Admin';
import LoginAsBuyer from './Public/LoginAsBuyer';
import LoginAsSupport from './Public/LoginAsSupport';
import Participant from './Public/Participant';
import PreCheckout from './Public/PreCheckout';
import PrintTicketPage from 'components/Pages/Public/PrintTicketPage';
import PrintSelectedTicketsPage from 'components/Pages/Public/PrintSelectedTicketsPage';

const PrivateRoute = ({ component: Component, ...rest }: any) => {
  const [user] = useObservable(() => authService.getUser(), []);

  useEffect(() => {
    if (!user) {
      const acpoToken = localStorage.getItem('authTokenAcpo') || null;
      authService.loginAccounts(acpoToken);
      return;
    }
    gtag('set', 'user_id', user?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id]);

  if (!user) {
    return <PageLoader />;
  }

  return <Route {...rest} render={props => <Component {...props} />} />;
};

const Pages = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route path='/precheckout/:event_id/:transaction_key' exact component={PreCheckout} />
        <Route path='/login/byeventhash/:hash' exact component={LoginAsBuyer} />
        <Route path='/login/login_as/:email/:hash/:page?' exact component={LoginAsSupport} />
        <Route path='/login/as_support/:email/:hash/:page?' exact component={LoginAsSupport} />
        <PrivateRoute exact path='/participant/print/' component={PrintSelectedTicketsPage} />
        <PrivateRoute path='/participant/print/:id/:is_gift/:attendance_id?' component={PrintTicketPage} />

        <Route path='/participant/:ciphertext' exact component={Participant} />

        <PrivateRoute path='/' component={AdminPage} />
        <Route render={() => <Redirect to='/' />} />
      </Switch>
    </BrowserRouter>
  );
};

export default Pages;
